import styled from 'styled-components';

export const Container = styled.div`
  margin: 60px auto 0 auto;
  background-color: #799ee2;
  width: 360px;
  height: 100%;
  padding: 80px;
  border-radius: 4px;

  h1 {
    text-align: center;
    font-size: 36px;
    margin-bottom: 20px;
  }

  h2 {
    text-align: center;
    font-size: 26px;
    margin-top: 28px;
    margin-bottom: 18px;
  }
`;
